import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpStatusCode} from "@angular/common/http";
import {LocalStorageService, CustomMessageService, ResponseHttpSuccess, ResponseHttpError, CustomMessageKey, UtilService} from 'library';
import {LocalStorageKey} from "projects/store/src/app/enums";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";
import {UserService} from "projects/store/src/app/services/api/v1/user.service";
import { User } from "projects/store/src/app/interfaces";
import {environment} from "projects/store/src/environments/environment";
import {DOCUMENT} from "@angular/common";

interface Store {
  "id": string,
  "name": string,
  "settings": {
    "user_verification_enabled": boolean
  }
}

enum StepOptions {
  login = 'login',
  check = 'check',
  validate = 'validate',
  retry = 'retry',
  waiting = 'waiting',
  closed = 'closed'
}
@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html'
})

export class AuthComponent implements OnInit{
  minScore = 0.7;
  form: FormGroup;
  submitted: boolean = false;
  loading: boolean = false;
  user!: User;
  store!: Store;
  mati!: { client_id: string, flow_id: string}
  step: string = StepOptions.login;
  stepOptions = StepOptions;
  srcLogo: string = '';
  constructor(private router: Router,
              private route: ActivatedRoute,
              private authService: AuthService,
              private utilService: UtilService,
              private userService: UserService,
              private localStorageService: LocalStorageService,
              private customMessageService: CustomMessageService,
              @Inject(DOCUMENT) private document: Document) {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    if(themeLink) {
      themeLink.href = 'krediya.v2-theme.css';
    }

    this.form = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      password: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });

    this.srcLogo = `assets/images/${environment.global.country.code}/krediya-logo.svg`;
  }

  ngOnInit(): void {
    if(this.authService.isAuthenticated()) {
      this.router.navigate(['inicio'])
    }else{
      let token = this.route.snapshot.queryParams['token'];
      console.log(token);
      if(token !== undefined) {
        let decodedToken = atob(token).split(":");
        this.form.patchValue({email: decodedToken[0], password: decodedToken[1]})
        this.checkCredential()
      }
      this.localStorageService.clear();
    }
  }

  checkCredential() {
    this.customMessageService.clear();
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    this.loading = this.utilService.enablePageLoading();
    let data = { email: this.form.value.email, password: this.form.value.password };
    this.authService.checkCredential(data).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if(resp.status == HttpStatusCode.Ok) {
          this.localStorageService.set(LocalStorageKey.tempToken, data);
          this.user = resp.body.data.user;
          this.store = resp.body.data.store;
          //  TODO quitar despues de las pruebas
          this.login();
/*
          // TODO habilitar despues de las pruebas
          if(this.store?.settings.user_verification_enabled) {
            this.mati = resp.body.data.mati;
            this.step = this.user.confirmed ? StepOptions.check : StepOptions.validate;
            this.loading = this.utilService.disablePageLoading();
          }else{
            this.salesLogin();
          }
*/
        }else{
          this.customMessageService.responseNoticeHandler(resp)
          this.loading = this.utilService.disablePageLoading();
        }
      },
      error: (error: ResponseHttpError) => {
        if(error.status === HttpStatusCode.Unauthorized) {
          this.customMessageService.error('¡Ups! Parece que el correo o la clave no coinciden. Revisa que estén bien escritos e inténtalo otra vez. Si olvidaste tu clave, puedes recuperarla haciendo clic en "Olvidé mi contraseña".', CustomMessageKey.local);
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.loading = this.utilService.disablePageLoading();
      }
    });
  }

  login() {
    let data = this.localStorageService.get(LocalStorageKey.tempToken);
    this.authService.login(data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Ok) {
          this.localStorageService.set(LocalStorageKey.token, resp.body.data.access_token);
          this.localStorageService.remove(LocalStorageKey.tempToken);
          this.authService.authenticationNext(true);

          this.getUserInformation();
        }else{
          this.customMessageService.responseNoticeHandler(resp);
          this.loading = this.utilService.disablePageLoading();
        }
      },
      error: (error: ResponseHttpError) => {
        if(error.status === HttpStatusCode.Unauthorized) {
          this.localStorageService.remove(LocalStorageKey.token);
          this.customMessageService.error('¡Ups! Parece que el correo o la clave no coinciden. Revisa que estén bien escritos e inténtalo otra vez. Si olvidaste tu clave, puedes recuperarla haciendo clic en "Olvidé mi contraseña".', CustomMessageKey.local)
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.loading = this.utilService.disablePageLoading();;
      }
    });
  }

  salesLogin() {
    const token = btoa(this.form.value.email + ':' + this.form.value.password);
    window.location.href = `${environment.salesSiteURL}auth/login?token=${token}`;
  }

  onResponseCheckUser() {
    this.utilService.enablePageLoading();
    this.saveKYCResponse();

    let data = this.localStorageService.get(LocalStorageKey.data);
    if(data !== null) {
      if(data.status == 'closed') {
        let errorMessage = "La validacion de usuario no fue concluida. Por favor, vuelva a intentarlo";
        this.showError(errorMessage);
      }else if(data.status == 'finished') {
        if(this.checkScoreKYC(data.summary.score)) {
          this.login();
        }else{
          let errorMessage = "La validacion de usuario no fue satisfactoria. Por favor, asegurese de lo siguiente: " +
            "El email y clave sean suyos. Ubicarse en un recinto cerrado y que haya suficiente luz";
          this.showError(errorMessage);
        }
      }
    }else{
      this.step = StepOptions.login;
      console.error("Se presento un problema al buscar la respueta KYC", data);
      this.showError("La validación de usuario no pudo ser iniciada. Por favor, vuelva a intentarlo");
    }
  }

  onResponseValidateUser(resp: ResponseHttpSuccess | ResponseHttpError) {
    this.utilService.enablePageLoading();
    switch(resp.status) {
      case HttpStatusCode.Ok:
        this.loading = this.utilService.disablePageLoading();
        break;
      case HttpStatusCode.ResetContent:
        this.step = StepOptions.waiting;
        setTimeout(() => this.step = StepOptions.validate, 1000);
        break;
      case HttpStatusCode.NoContent:
        this.login();
        break;
      case HttpStatusCode.NotAcceptable:
        this.step = StepOptions.retry;
        this.loading = this.utilService.disablePageLoading();
        this.localStorageService.clear();
        break;
      case HttpStatusCode.Conflict:
        let errorMessage = "Su acceso ha sido denegado. Si tiene alguna duda, por favor, pongase en contacto con el equipo de soporte";
        this.showError(errorMessage);
        break;
      default:
        this.customMessageService.responseNoticeHandler(resp);
        this.step = StepOptions.login;
        this.loading = this.utilService.disablePageLoading();
        this.localStorageService.clear();
        // setTimeout(() => this.customMessageService.error(message, CustomMessageKey.local), 0);
    }
  }

  saveKYCResponse() {
    let data = this.localStorageService.get(LocalStorageKey.data)
    this.authService.saveKYCResponse(this.user.id, data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status !== HttpStatusCode.Created) {
          this.customMessageService.responseNoticeHandler({...resp, error: { message: "Se presento un problema al guardar la respueta KYC" }});
        }
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
      }
    });
  }

  getUserInformation() {
    this.userService.get(this.user.id).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Ok) {
          //  TODO quitar despues de las pruebas
          this.localStorageService.set(LocalStorageKey.data, resp.body.data);
          this.localStorageService.set(LocalStorageKey.salesModuleToken, btoa(this.form.value.email + ':' + this.form.value.password));
          this.router.navigate(['/inicio']);
          this.loading = this.utilService.disablePageLoading();
          //  TODO habilitar despues de las pruebas
          // this.salesLogin()
        }else{
          this.customMessageService.responseNoticeHandler(resp);
          this.loading = this.utilService.disablePageLoading();
        }
      },
      error: (error: ResponseHttpError) => {
        if(error.status === HttpStatusCode.Unauthorized) {
          this.localStorageService.remove(LocalStorageKey.token);
          this.customMessageService.error("Email o clave incorrecta. Por favor, vuelva a intentarlo", CustomMessageKey.local)
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.loading = this.utilService.disablePageLoading();;
      }
    });
  }

  showError(message: string) {
    this.step = StepOptions.login;
    this.loading = this.utilService.disablePageLoading();
    this.localStorageService.clear();
    setTimeout(() => this.customMessageService.error(message, CustomMessageKey.local), 0);
  }

  checkScoreKYC(score: {average: number, max: number, min: number}) {
    return score.max >= this.minScore;
  }

  get f() {
    return this.form.controls;
  }

  protected readonly CustomMessageKey = CustomMessageKey;
  protected readonly StepOptions = StepOptions;
}
